<template>
    <ui-data-table 
        :p-headers="headers"
        p-title="Centros de custo"
        p-read-link="costsCenters.read.one"
        p-create-link="costsCenters.create"
        p-name="costsCenters"
    />
</template>
<script>

import {uiDataTable} from '@/components/ui'
export default {
    name: 'vwcostCenterRead',
    components: {
        uiDataTable  
    },
    data(){
        return {
            headers: [{
                text: 'id',
                value: 'id'
            }, {
                text: 'descrição',
                value: 'descricao'
            }, {
                text: 'Cadastrado',
                value: 'criado_em'
            }, {
                text: 'Ações', 
                value: 'actions', 
                sortable: false
            }],
        }
    },
}
</script>